import { Grid, TextButton, Elements } from '@tfo/common'
import { inject } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { Link } from 'react-router-dom'
import Attachments from '../../common/attachments/Attachments'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Instructions from '../../common/instructions/Instructions'
import { AwaitResponseViewModel } from '../../ViewModels'

import './AwaitResponse.scss'
import { ApprovalState } from '../../../../models/Enums'

const { Paragraph } = Elements
const { GridWrapper } = Grid

type AwaitResponseProps = AwaitResponseViewModel 

const AwaitResponse: React.FunctionComponent<AwaitResponseProps &
	WrappedComponentProps> = (props) => {
		const { companyName, orderId } = props

		//NOTE: Temporary until we only pass signatures via portal
		const canBeSigned = props.approval.type !== ApprovalState.Signature || props.approval.canAccept;

		const getListItem = (text: string) => {
			return (
				<ListItem>
					<ListItemIcon>
						<FiberManualRecordIcon fontSize='small' />
					</ListItemIcon>
					<ListItemText>
						<Paragraph>
							{props.intl.formatMessage({ id: text })}
						</Paragraph>
					</ListItemText>
				</ListItem>
			)
		}

		return (
			<GridWrapper className={'IndividualView AwaitResponse'}>
				<IndividualHeader
					companyName={companyName}
					headingId="awaitResponse.heading"
					preambleId={!canBeSigned ? "startIndividual.signature.body" : "awaitResponse.body"}
					preambleData={{
						companyName: companyName,
					}}
				/>
				{!canBeSigned && props.canAttachFile &&
					<div>
						<div className="Bullet-list">
							<List>
								{getListItem('requireAttachments.attach.approvebyemail')}
								{getListItem('requireAttachments.attach.attachfile')}
							</List>
						</div>

						{props.instructions && <Instructions {...props} />}
						<Attachments {...props} />
					</div>
				}

				{canBeSigned &&
					<div className={'IndividualButtons'}>
						<Link to={`approval/${orderId}`}>
							<TextButton
								className="AwaitResponse__TextButton AwaitResponse__TextButton--right">
								{props.intl.formatMessage({ id: 'awaitResponse.btn.change' })}
							</TextButton>
						</Link>
					</div>
				}
			</GridWrapper>
		)
	}

export default inject('rootStore')(injectIntl(AwaitResponse))
